export enum EPaginationSortDir {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface IPaginationTableHeader {
  label: string;
  sortDir?: EPaginationSortDir;
  sortable?: boolean;
  textAlign?: string;
  nameColumnOrderBy?: string;
  tippy?: string;
}

export interface IPagination {
  next: string | null;
  mustCallApi: boolean;
}

export default class PaginationUtils {
  static getSortDir(sortDir?: EPaginationSortDir) {
    if (!sortDir) return EPaginationSortDir.ASC;

    const sortMapper = {
      [EPaginationSortDir.ASC]: EPaginationSortDir.DESC,
      [EPaginationSortDir.DESC]: EPaginationSortDir.ASC
    };

    return sortMapper[sortDir];
  }

  static defaultPagination(): IPagination {
    return {
      next: null,
      mustCallApi: true
    };
  }

  static makeNewRequest(
    { triggerClass = '', hasPagination = false },
    cb: () => void
  ) {
    const triggerEl = document.querySelector(triggerClass);

    if (!triggerEl || !triggerClass || !hasPagination) return;

    setTimeout(() => {
      const trigger = triggerEl.getBoundingClientRect() as DOMRect;

      if (trigger.y <= window.innerHeight && hasPagination) {
        cb();
      }
    }, 0);
  }

  static getUpdatedHeaders(
    field: string,
    headers: Record<string, IPaginationTableHeader>
  ) {
    const headerEntries = Object.entries(headers).map(
      ([headerField, value]) => {
        if (field === headerField) {
          return [
            headerField,
            {
              ...value,
              sortDir: this.getSortDir(value.sortDir)
            }
          ];
        }

        return [
          headerField,
          {
            ...value,
            sortDir: undefined
          }
        ];
      }
    );

    return Object.fromEntries(headerEntries);
  }
}
